
























































import { Component } from "vue-property-decorator";
import Header from "@/components/designer/header/Header.vue";
import { User, UserProfileSchema } from "@/models/user/user";
import UserService from "@/services/user_service";
import AuthService from "@/services/auth_service";
import Share from "@/components/share/Share.vue";
import {
  AuthError,
  GenericError,
  NotFoundError,
  PermissionsError,
} from "@/services/error_service";
import { mixins } from "vue-class-component";
import { ConfigCreator } from "@/mixins/configurator";

@Component({
  components: { Header, Share },
})
export default class UserProfile extends mixins(ConfigCreator) {
  protected userService = new UserService();
  protected authService = new AuthService();
  protected user: null | User = null;
  protected pwRequested = false;
  protected firstName = "";
  protected lastName = "";
  protected nameRules = [
    (v: string) => !!v || "Name is required",
    (v: string) => /^[\p{L} ,.'-]+$/u.test(v) || "Only letters allowed in name",
  ];
  protected email = "";
  protected emailRules = [
    (v: string) => !!v || "E-mail is required",
    (v: string) => /.+@.+/.test(v) || "E-mail must be valid",
  ];

  async created() {
    this.getUserInfo();
  }

  public async getUserInfo(): Promise<void> {
    const loader = this.$loading.show();
    try {
      this.user = await this.userService.getUserProfile();
      this.firstName = this.user.first_name;
      this.lastName = this.user.last_name;
      this.email = this.user.email;
    } catch (err) {
      if (err instanceof PermissionsError) {
        PermissionsError.popup(err.message, err.statusCode);
      } else if (err instanceof AuthError) {
        AuthError.logout();
      } else {
        GenericError.popup(err.message);
      }
    }
    loader.hide();
  }

  public async requestNewPassword(): Promise<void> {
    window.location.replace(
      `${process.env.VUE_APP_LOGIN_URL}/request-email?request=password`
    );
  }

  protected submitProfile(): void {
    let loader = this.$loading.show();
    const body = {
      first_name: this.firstName,
      last_name: this.lastName,
      email: this.email,
    } as UserProfileSchema;
    try {
      this.userService.updateUserProfile(body);
      loader.hide();
      loader = this.$loading.show(
        {},
        { before: this.$createElement("h1", "Saved!") }
      );
      setTimeout(() => loader.hide(), 500);
    } catch (err) {
      loader.hide();
      if (err instanceof PermissionsError) {
        PermissionsError.popup(err.message, err.statusCode);
      } else if (err instanceof AuthError) {
        AuthError.logout();
      } else {
        GenericError.popup(err.message);
      }
    }
  }
}
